import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {WEEKLY_CHECK_INS} from '/enum/clientJourneyTasks.enum';
import {
  clientJourneyTasksByType,
  currentWeeklyCheckInDate,
  lastWeeklyCheckInDate,
} from '/redux/selector/client.selector';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import {TaskDetails} from './TaskDetails';

export default connect(
  createStructuredSelector({
    currentCheckInDate: currentWeeklyCheckInDate,
    lastCheckInDate: lastWeeklyCheckInDate,
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    weeklyCheckInsTasks: withProps({type: WEEKLY_CHECK_INS})(
      clientJourneyTasksByType,
    ),
  }),
)(TaskDetails);
